module.exports = __webpack_public_path__ + "fonts/Axiforma-Regular.c4f8a96.ttf";